import GoogleOneTapSession from './google_one_tap_session.mjs'

const GIS_SRC = 'https://accounts.google.com/gsi/client'

// Loads the Google Identity Services script only on pages that render <google-one-tap>
// (signed-out signup email step and login page).
const loadGoogleIdentityServices = (cspNonce) => {
  if (window.google?.accounts?.id) return Promise.resolve()
  if (window.__signwithGisLoading) return window.__signwithGisLoading

  window.__signwithGisLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = GIS_SRC
    script.async = true
    script.defer = true
    if (cspNonce) script.nonce = cspNonce
    script.onload = () => resolve()
    script.onerror = () => {
      window.__signwithGisLoading = null
      reject(new Error('Google Identity Services failed to load'))
    }
    document.head.appendChild(script)
  })

  return window.__signwithGisLoading
}

export default class GoogleOneTap extends HTMLElement {
  connectedCallback () {
    this.session = new GoogleOneTapSession({
      root: document,
      getGoogle: () => window.google,
      clientId: this.dataset.clientId,
      context: this.dataset.context,
      nonce: this.dataset.nonce,
      onCredential: (credential) => this.submitCredential(credential)
    })
    this.session.listen()

    loadGoogleIdentityServices(this.dataset.cspNonce)
      .then(() => { if (this.isConnected) this.session.start() })
      .catch(() => {})
  }

  // Turbo navigation away (or the page body being replaced) disconnects the element.
  disconnectedCallback () {
    this.session?.stop()
  }

  submitCredential (credential) {
    const form = document.createElement('form')
    form.method = 'post'
    form.action = this.dataset.endpoint
    form.dataset.turbo = 'false'
    form.hidden = true

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const param = document.querySelector('meta[name="csrf-param"]')?.content || 'authenticity_token'
    const fields = { credential, context: this.dataset.context }
    if (token) fields[param] = token

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
